import './index.css';
import GLightbox from 'glightbox';

document.addEventListener('DOMContentLoaded', () => {
    // Instance #1 — image gallery
    const galleryLightbox = GLightbox({
        selector: '.glightbox',
        touchNavigation: true,
        loop: true,
    });

    // Instance #2 — text modals (completely separate)
    const textLightbox = GLightbox({
        selector: '.js-text-lightbox',
        touchNavigation: false,
        closeOnOutsideClick: true,
        keyboardNavigation: false,
    });

    // Optionally store globally for close button access
    window.textModal = textLightbox;
});
